import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, TransitionGroup as _TransitionGroup, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "pb-3 text-left" }
const _hoisted_2 = { class: "pb-3 text-left" }
const _hoisted_3 = {
  class: "text-left",
  key: "sumsLabel"
}
const _hoisted_4 = ["textContent"]
const _hoisted_5 = {
  key: "familyMemberCountError",
  class: "text-left"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Du skal vælge en indbo sum'
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  class: "pb-5",
  key: "spacer"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  class: "text-left pb-3",
  key: "vaelg"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { textContent: 'Vælg din pakke' }, null, -1)
const _hoisted_12 = { key: "packages" }
const _hoisted_13 = ["id"]
const _hoisted_14 = {
  key: 0,
  class: "package__recommendation"
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["textContent"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["textContent"]
const _hoisted_19 = ["textContent"]
const _hoisted_20 = ["textContent"]
const _hoisted_21 = ["textContent"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "strong" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopoverComponent = _resolveComponent("PopoverComponent")!
  const _component_SegmentedControlComponent = _resolveComponent("SegmentedControlComponent")!
  const _component_SelectModalComponent = _resolveComponent("SelectModalComponent")!
  const _component_ButtonTapComponent = _resolveComponent("ButtonTapComponent")!
  const _component_PackageBlockComponent = _resolveComponent("PackageBlockComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showExcessChoice)
      ? (_openBlock(), _createBlock(_component_SegmentedControlComponent, {
          key: 0,
          class: "pb-3",
          id: "ownRiskId",
          options: _ctx.ownRiskOptions,
          labels: _ctx.ownRiskLabels,
          preSelected: _ctx.model.choosePackage.ownRiskId + '',
          controlsPerRow: 3,
          onSegmentedComponent: _ctx.handleSegmentedProperty
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", null, _toDisplayString(_ctx.selvriskoLabel), 1),
              (_ctx.cms.selvrisikoPopover)
                ? (_openBlock(), _createBlock(_component_PopoverComponent, {
                    key: 0,
                    type: "icon",
                    class: "page-component__popover",
                    buttonClass: "popover__icon popover__icon__questionmark",
                    innerData: _ctx.cms.selvrisikoPopover
                  }, null, 8, ["innerData"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["options", "labels", "preSelected", "onSegmentedComponent"]))
      : _createCommentVNode("", true),
    _createVNode(_TransitionGroup, { name: "slide-simple" }, {
      default: _withCtx(() => [
        (_ctx.showSegmentedProductProperty)
          ? (_openBlock(), _createBlock(_component_SegmentedControlComponent, {
              key: "segmentedProductProperty",
              class: "pb-3",
              id: "segmentedProductProperty",
              options: _ctx.model.calculation.abCalc.segmentedProductProperties,
              labels: _ctx.model.calculation.abCalc.segmentedProductProperties,
              preSelected: _ctx.model.choosePackage.segmentedProductProperty,
              controlsPerRow: 3,
              onSegmentedComponent: _ctx.handleSegmentedProperty
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.cms.segmentedProductPropertiesLabel), 1),
                  (_ctx.cms.segmentedProductPropertyPopover)
                    ? (_openBlock(), _createBlock(_component_PopoverComponent, {
                        key: 0,
                        type: "icon",
                        class: "page-component__popover",
                        buttonClass: "popover__icon popover__icon__questionmark",
                        innerData: _ctx.cms.segmentedProductPropertyPopover
                      }, null, 8, ["innerData"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["options", "labels", "preSelected", "onSegmentedComponent"]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", {
            key: "sumsLabel1",
            class: "input__label text-left",
            for: "sums",
            textContent: _toDisplayString(_ctx.cms.sumsLabel)
          }, null, 8, _hoisted_4)
        ], 512), [
          [_vShow, _ctx.showSums && _ctx.model.choosePackage.ownRiskId]
        ]),
        (_ctx.showSums && _ctx.model.choosePackage.ownRiskId)
          ? (_openBlock(), _createBlock(_component_SelectModalComponent, {
              key: "sums",
              id: "sums",
              name: "sums",
              preSelect: _ctx.model.choosePackage.insuredValue,
              innerData: _ctx.sums,
              selected: _ctx.model.choosePackage.insuredValue !== undefined,
              placeholder: _ctx.cms.sumsSelectDefault,
              visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
              errorMsgOverride: "Du skal vælge et forsikringsselskab",
              "onSelectModalComponent:selected": _ctx.sumSelected
            }, null, 8, ["preSelect", "innerData", "selected", "placeholder", "visibleError", "onSelectModalComponent:selected"]))
          : _createCommentVNode("", true),
        (!_ctx.model.pristineStep.get(_ctx.card.name) && _ctx.model.choosePackage.insuredValue === undefined)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7, 512)), [
              [_vShow, _ctx.showSums && _ctx.model.choosePackage.ownRiskId]
            ])
          : _createCommentVNode("", true),
        (_ctx.showSums && _ctx.model.choosePackage.ownRiskId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-vertical-no-delay" }, {
      default: _withCtx(() => [
        (_ctx.model.calculation.isCalculated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                (_ctx.cms.packageInfoPopover)
                  ? (_openBlock(), _createBlock(_component_PopoverComponent, {
                      type: "icon",
                      key: "packageInfoPopover",
                      class: "page-component__popover text-left",
                      buttonClass: "popover__icon popover__icon__info",
                      innerData: _ctx.cms.packageInfoPopover
                    }, null, 8, ["innerData"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.calculation.abCalc.packs.get(_ctx.model.choosePackage.ownRiskId), (pack, inx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "package",
                    id: pack.name,
                    key: 'cov' + inx
                  }, [
                    (_ctx.getSplashText(pack.name))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
									'package__recommendation__content',
									{
										package__recommendation__content__icon: _ctx.isSplashIcon(pack.name),
									},
									{ showIcon: _ctx.showSplashIcon },
								])
                          }, [
                            _createElementVNode("div", null, [
                              _createElementVNode("span", {
                                innerHTML: _ctx.getSplashText(pack.name)
                              }, null, 8, _hoisted_15),
                              (_ctx.cms.recommendationPopover)
                                ? (_openBlock(), _createBlock(_component_PopoverComponent, {
                                    key: 0,
                                    type: "icon",
                                    class: "page-component__popover",
                                    buttonClass: "popover__icon popover__icon__questionmark",
                                    innerData: _ctx.cms.recommendationPopover
                                  }, null, 8, ["innerData"]))
                                : _createCommentVNode("", true)
                            ])
                          ], 2)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", {
                      class: "h1-pretitle",
                      textContent: _toDisplayString(pack.name)
                    }, null, 8, _hoisted_16),
                    (_ctx.cms.packageSubheader)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          innerHTML: _ctx.cms.packageSubheader
                        }, null, 8, _hoisted_17))
                      : _createCommentVNode("", true),
                    (_ctx.model.choosePackage.monthYear === 'M')
                      ? (_openBlock(), _createElementBlock("h2", {
                          key: _ctx.model.calculation.updatePrices[inx],
                          class: _normalizeClass({ 'loading ml-n3': _ctx.showLoading(pack) }),
                          textContent: _toDisplayString(_ctx.showLoading(pack) ? '' : pack.totalPriceDisplay)
                        }, null, 10, _hoisted_18))
                      : (_openBlock(), _createElementBlock("h2", {
                          key: _ctx.model.calculation.updatePrices[inx] + '1',
                          class: _normalizeClass({
								'loading ml-n3': pack.yearlyPriceTotalDisplay === undefined,
							}),
                          textContent: _toDisplayString(pack.yearlyPriceTotalDisplay)
                        }, null, 10, _hoisted_19)),
                    _createElementVNode("p", {
                      class: "subtext",
                      textContent: _toDisplayString(_ctx.model.choosePackage.monthYear === 'M' ? 'Pr. måned' : 'Pr. år')
                    }, null, 8, _hoisted_20),
                    (_ctx.cms.showYearlyPrices)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 4,
                          class: _normalizeClass([
								{ subtext: pack.yearlyPriceTotalDisplay !== undefined },
								{ 'loading ml-n3': pack.yearlyPriceTotalDisplay === undefined },
							]),
                          textContent: _toDisplayString(pack.yearlyPriceTotalDisplay && pack.yearlyPriceTotalDisplay + ' Årligt')
                        }, null, 10, _hoisted_21))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ButtonTapComponent, {
                      class: _normalizeClass([
								_ctx.card.buttonStyle,
								'order-btn',
								{
									'btn-disabled': _ctx.model.choosePackage.monthYear === 'M' && _ctx.showLoading(pack),
								},
								{
									'btn-disabled':
										_ctx.model.choosePackage.monthYear === 'Y' &&
										pack.yearlyPriceTotalDisplay === undefined,
								},
							]),
                      onClick: ($event: any) => (_ctx.selectPackage(inx)),
                      "data-gtm": _ctx.cms.dataGtm,
                      "data-gtm-click-text": 'beregning_valg/' + pack.name
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.getChoosePackageBtnLabel(_ctx.card, pack.name)), 1)
                      ]),
                      _: 2
                    }, 1032, ["class", "onClick", "data-gtm", "data-gtm-click-text"]),
                    (_ctx.cms.extendCoverages && inx > 0)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 5,
                          onClick: ($event: any) => (_ctx.scrollToPack(inx)),
                          class: "highlights fill pointer mb-4 ml-3 mr-3 ml-md-6 mr-md-6"
                        }, [
                          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.getPrevExtendedPackName(inx)), 1),
                          _createTextVNode(" inkluderet ")
                        ], 8, _hoisted_22))
                      : _createCommentVNode("", true),
                    _createVNode(_component_PackageBlockComponent, {
                      class: "text-left mt-0",
                      coverages: _ctx.getCoveragePackage(inx),
                      track: false,
                      trackGtm: true,
                      trackGtmLabel: pack.name
                    }, null, 8, ["coverages", "trackGtmLabel"])
                  ], 8, _hoisted_13))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}